
  import {css} from 'lit';
  export const EplibStyles = css`
  @font-face {
  font-family: 'IM Fell English';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/imfellenglish/v14/Ktk3ALSLW8zDe0rthJysWrnLsAzHFaOd.ttf) format('truetype');
}
@font-face {
  font-family: 'IM Fell English';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/imfellenglish/v14/Ktk1ALSLW8zDe0rthJysWrnLsAz3Fw.ttf) format('truetype');
}
@font-face {
  font-family: 'Material Icons';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/materialicons/v145/flUhRq6tzZclQEJ-Vdg-IuiaDsNZ.ttf) format('truetype');
}
.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
}
.logo {
  background: url('../images/icon.png') top center no-repeat;
  background-size: auto 100%;
  color: transparent;
  width: 290px;
}
a {
  color: #335eb5;
  text-decoration: none;
}
#main-container {
  max-width: 1600px;
}
.main {
  margin-top: 50px;
  margin-bottom: 20px;
}
.actions-row {
  position: static;
  z-index: 10;
  background-color: whitesmoke;
  border-bottom: 1px solid #ddd;
  left: 0;
  width: 100%;
  --bs-gutter-x: 0;
}
#content {
  min-height: 85vh;
}
#content-inner {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 16px;
}
.content {
  padding-bottom: 30px;
  position: relative;
}
.content h1 {
  font-size: 1.75em;
}
.content h2 {
  font-size: 1.67em;
}
.content h3 {
  font-size: 1.33em;
}
.content h4 {
  font-size: 1.25em;
}
.content > * > section {
  border-top: 1px solid #777;
  margin: 2.5em 0;
  padding-top: 2em;
}
.content mark {
  background-color: #FFEB3B;
}
.content .match {
  background-color: #EEBB33 !important;
}
.content .code1 {
  font-family: "Ubuntu Mono", Menlo, Consolas, Courier, monospace;
}
.content .alternate .altcontent {
  display: none;
}
.content .note,
.content .popover {
  font-size: 13px;
}
.content .note {
  vertical-align: super;
  cursor: pointer;
  margin-left: 0.25em;
}
.content .margin-note-ref {
  font-size: small;
  vertical-align: super;
  color: #777;
  margin-right: 4px;
}
.content .margin-note {
  background: #B6B6B6;
  display: block;
  font-size: small;
  margin-right: -200px;
  margin-bottom: 5px;
  padding: 5px;
  float: right;
  clear: both;
  width: 190px;
}
.content .margin-note .n {
  color: #777;
}
@media (max-width: 768px) {
  .content .margin-note {
    display: none;
  }
  .content .margin-right {
    margin-right: 0;
  }
}
.content .pb,
.content .pb2 {
  font-size: small;
  float: none !important;
  display: inline !important;
  margin: 0 !important;
  color: #eeeeee;
}
.content .pb:before {
  content: '[p. ' !important;
}
.content .label:not(.note) {
  font-weight: bold;
  font-size: inherit;
  color: inherit;
  padding: inherit;
  margin: inherit;
}
.content .wordcount {
  position: absolute;
  color: red;
  font-size: xx-small;
  left: -1.25rem;
}
#content-container {
  -webkit-animation-duration: 400ms;
  -moz-animation-duration: 400ms;
  animation-duration: 400ms;
  height: 85vh;
  overflow: auto;
}
@media (max-width: 768px) {
  #content-container {
    margin-bottom: 5em;
  }
}
@media (min-width: 769px) {
  .margin-right {
    margin-right: 200px;
    position: relative;
  }
}
/* Page by page navigation */
#content-inner {
  min-height: 450px;
}
body {
  font-family: Georgia, "Times New Roman", serif !important;
  background: url('../images/press_paper.png') top left repeat;
  font-size: 16px !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "IM Fell English", serif !important;
  line-height: 1.2 !important;
}
.container .well,
body .container-fluid li.well {
  padding: 10px;
}
.well {
  padding: 0;
  min-height: 50vh;
  max-height: 85vh;
  overflow-y: auto;
}
.wrapper {
  margin-right: auto;
  margin-left: auto;
  margin-top: 30px;
  padding-right: 30px;
  padding-left: 30px;
  background-color: #fff;
  display: inline-block;
}
.transparent {
  background-color: rgba(255, 255, 255, 0.96);
}
.page-header {
  margin: 0.75rem 0.5rem 2rem 0.5rem;
}
#annotations {
  font-size: 12px;
  background: white;
  position: fixed;
  right: 0;
  top: 10vh;
  width: 400px;
  min-height: 45vh;
  max-height: 95vh;
  resize: vertical;
  overflow-y: auto;
  draggable: true;
  box-shadow: -5px 0px 8px -1px rgba(102, 102, 102, 0.5);
  z-index: 10;
  --bs-gutter-x: 0;
}
@media (max-width: 768px) {
  #annotations {
    position: absolute;
    z-index: 99;
    top: 0;
    right: -15px;
    max-width: 70%;
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.4);
  }
}
.doc-area {
  position: relative;
}
.page-item.active .page-link {
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}
.page-item .page-link {
  color: #337ab7;
  background-color: #fff;
  border-color: #fff;
  border: 1px solid #ddd;
}
.page-item .page-link:hover {
  background-color: #ddd;
}
.page-item {
  line-height: 1;
}
.list-browse .pagination {
  margin: 0;
  float: right;
  margin-bottom: 1rem;
}
.list-browse .form-inline .form-group .form-group-sm {
  margin: 0;
}
.list-browse .form-group,
.form-control {
  margin: 0;
  padding-bottom: 0;
  font-size: 14px;
  height: 34px;
}
.list-browse .form-group label {
  color: black;
}
.form-horizontal .control-label {
  display: inline-block;
  padding-top: 7px;
  text-align: right;
}
.list-browse .form-group label.control-label {
  font-size: 14px;
  font-weight: 100;
  margin: 8px 0 0 0;
}
.list-browse .form-group .col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9 {
  padding-right: 2px;
  padding-left: 2px;
  font-size: 12px;
  float: left;
  line-height: 1.42;
}
.list-browse .col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12 {
  padding-right: 0px;
  padding-left: 0px;
}
.list-browse ul {
  margin-left: -15px;
  list-style-type: none;
}
.list-browse input[type="checkbox"],
input[type="radio"] {
  margin: 14px 0 0 ;
}
.actions {
  margin-top: 2px;
}
#right-panel {
  margin-top: 12px;
}
.btn-group .hidden-xs {
  margin-left: 0.5em;
}
.btn-group .hidden-xs + span {
  margin-left: 0.5em;
}
.kwic_results {
  padding-left: 0.75rem;
}
.kwic_results ul {
  padding-left: 0.5rem;
}
.kwic_results li {
  list-style: none;
  border-top: 1px solid #C0C0C0;
  font-family: Georgia, "Times New Roman", serif !important;
  font-size: 16px;
}
.kwic_results > li > ul > li {
  border-top: 0.25px solid #C0C0C0;
}
.hit-count {
  float: right;
}
.hit-count-header {
  text-align: right;
  padding-right: 0px;
  font-size: 10px;
}
.browse {
  font-size: 1em !important;
}
.browse td:nth-child(2),
.browse td:nth-child(3),
.browse td:nth-child(4) {
  font-family: Georgia, "Times New Roman", serif !important;
}
.browse td:nth-child(5) {
  width: 180px;
  text-align: right;
}
.nav-button-group {
  position: fixed;
  left: 15px;
  z-index: 100;
  width: 200px;
}
.nav-button-group .btn.btn-fab {
  width: 36px;
  height: 36px;
  min-width: 36px;
}
.navbar .navbar-brand {
  line-height: 1;
  height: 56px;
}
.container-fluid > .navbar-header {
  margin-left: -15px;
}
.navbar-default {
  margin-bottom: 0;
  background-color: #4f4f4f !important;
}
.navbar-default .navbar-brand,
.navbar-default .navbar-brand:focus,
.navbar-default .navbar-brand:hover {
  background: url('../images/icon.png') top center no-repeat;
  background-size: auto 100%;
  color: transparent;
  width: 290px;
}
.navbar {
  padding-top: 0;
  padding-bottom: 0;
}
.navbar .navbar-nav {
  color: white;
  font-family: "IM Fell English", serif;
}
.navbar .navbar-nav > li > a:hover {
  background-color: white;
  font-weight: bold;
  color: #4f4f4f;
}
.navbar .navbar-nav > li > a {
  line-height: 36px;
}
.navbar-nav {
  float: left;
  margin: 0;
}
.navbar .navbar-nav > li > a {
  color: inherit;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 1.25rem;
  padding-left: 1.25rem;
}
.nav-item .submenu {
  display: none;
  position: absolute;
  left: 100%;
  top: -7px;
}
.nav-item .submenu-left {
  right: 100%;
  left: auto;
}
ul.dropdown-menu {
  font-size: inherit;
}
.dropdown-menu > li > a {
  padding: 8px 20px;
}
.menu-highlight {
  background-color: white;
  font-weight: bold;
  color: #4f4f4f;
}
.site-title {
  font-family: "IM Fell English", serif;
  font-style: italic;
  font-size: 26px;
  font-weight: 300;
  letter-spacing: -1px;
  margin-bottom: 0px;
  margin-right: 25px;
  float: left;
}
.top {
  margin-top: 61px;
}
.panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
  color: inherit;
}
.panel.panel-primary > .panel-heading {
  background-color: #C5CAE9;
}
.panel.panel-info > .panel-heading {
  background-color: #607D8B;
}
.search {
  margin-top: 81px;
}
.form__search {
  width: 100%;
  padding: 0 2rem;
  margin: 0 0 3.5rem 0;
}
.errors .list-group {
  margin: 10px 8px;
}
.errors .list-group-item-success,
.errors .list-group-item-danger {
  padding: 8px;
}
footer {
  color: white;
  background-color: #4f4f4f;
}
footer .row {
  margin: 18px;
}
footer .poweredby a {
  margin-right: 50px;
}
footer .poweredby img {
  height: 60px;
  padding: 8px;
}
.empty-page:after {
  background: #ddd none repeat scroll 0 0;
  border-radius: 3px;
  content: 'Empty page; please navigate with ">" or page-bottom slider.';
  display: inline-block;
  font-size: 1.2em;
  font-style: italic;
  margin: 18px 0;
  padding: 4px 12px;
  text-align: center;
  width: 100%;
}
.tooltip .tooltip-inner {
  text-align: left;
  margin: 0;
  background-color: #4f4f4f;
}
.narrow a.btn.btn-default {
  padding-left: 10px;
  padding-right: 10px;
}
a.on.btn.btn-default {
  font-weight: 700;
  color: #3F51B5;
  background: white;
}
a:active.on,
a:focus.on {
  background: inherit;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}
[rendition='#hi'] {
  font-style: italic;
}
[rend='hi'] {
  font-style: italic;
}
.form-group.is-focused .form-control {
  outline: 0;
  background-image: linear-gradient(#4f4f4f, #4f4f4f), linear-gradient(#D2D2D2, #D2D2D2);
  background-size: 100% 2px,100% 1px;
  box-shadow: none;
  transition-duration: 0.3s;
}
.form-control,
.form-group .form-control {
  border: 0;
  background-image: linear-gradient(#4f4f4f, #4f4f4f), linear-gradient(#D2D2D2, #D2D2D2);
  background-size: 0 2px,100% 1px;
  background-repeat: no-repeat;
  background-position: center bottom, center calc(100% - 1px);
  background-color: rgba(0, 0, 0, 0);
  transition: background 0s ease-out;
  float: none;
  box-shadow: none;
  border-radius: 0;
}
.form-group .form-control {
  margin-bottom: 4px;
}
.btn-group-sm .btn,
.btn-group-sm .input-group-btn .btn,
.btn.btn-sm,
.input-group-btn .btn.btn-sm {
  padding: 5px 20px;
  font-size: 12px;
}
.btn-default:hover {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}
.btn,
.input-group-btn .btn {
  border: none;
  border-radius: 2px;
  margin: 5px 1px;
  text-transform: uppercase;
  letter-spacing: 0;
  will-change: box-shadow, transform;
  transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  outline: 0;
  cursor: pointer;
  text-decoration: none;
  background: 0 0;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}
.material-icons.md-16 {
  font-size: 16px;
}
.material-icons {
  position: relative;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
}
.form-group select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.container-fluid .well {
  background-color: #fff;
  padding: 0.25rem 0.75rem 0.25rem 0.75rem;
  -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.btn:not(.btn-raised),
.btn:not(.btn-raised).btn-default,
.input-group-btn .btn:not(.btn-raised),
.input-group-btn .btn:not(.btn-raised).btn-default {
  color: rgba(0, 0, 0, 0.87);
}
button[aria-expanded=true] .glyphicon-triangle-right {
  display: none;
}
button[aria-expanded=false] .glyphicon-triangle-bottom {
  display: none;
}
.card-body {
  padding: 20px;
}
.card-header .btn-block {
  text-align: left;
}
details > summary {
  font-size: 1rem;
  display: flex;
  width: 100%;
  background: linear-gradient(360deg, #fdfdfd 0%, #cdcdcd 100%);
  padding: 0.75rem 0.75rem 0rem 0.75rem;
  cursor: pointer;
  list-style: none;
  justify-content: space-between;
}
summary::-webkit-details-marker {
  display: none;
}
summary::after {
  font-family: "Material Icons";
  font-size: 1.25rem;
  content: "\\e5cf";
}
details[open] > summary::after {
  font-family: "Material Icons";
  font-size: 1.25rem;
  content: "\\e5ce";
}
details > summary:hover {
  color: #333;
  background: linear-gradient(360deg, #fdfdfd 0%, #e9e9e9 100%);
  border-color: #adadad;
}
details[name="home_accordion"] > div {
  padding: 0.5rem;
}
.caret-left {
  border-bottom: 4px solid transparent;
  border-top: 4px solid transparent;
  border-right: 4px solid #000000;
  margin-right: 8px;
  display: inline-block;
  height: 0;
  opacity: 1;
  vertical-align: middle;
  width: 0;
}
.dropdown:hover > .dropdown-menu {
  display: block;
  margin-top: 0;
}
.dropdown-menu > li:hover > .submenu {
  display: block;
  margin-top: 0;
}
.dropdown-menu li {
  position: relative;
}
.kwic-highlight {
  background-color: yellow;
}
.kwic-current {
  background-color: orange;
}
.kwic-controls span {
  align-self: center;
  justify-self: center;
}
#perpage {
  text-align: center;
  width: 5rem;
}
eplib-page-slider {
  display: grid;
  justify-items: stretch;
  align-items: start;
  padding-top: 0.5rem;
}
.loading {
  width: 100%;
  border-bottom: 0.25rem solid #4f4f4f;
}
tei-w {
  display: inline-block;
}
.decorinit::first-letter {
  font-size: 1.5em;
  line-height: 1;
  margin-right: 0.1em;
  font-weight: bold;
  color: #983722;
}

  `;
  